import { Attributes } from '@wordpress/block-serialization-default-parser/build-types';
import { DateTime } from 'luxon';
import React, { JSX, MutableRefObject } from 'react';


export type SliderData
=
{
    src: string,
    link: string,
    validUntil: number,
    title?: string
    id: number
}

export enum SubscriberLevel
{
    gold = 'gold',
    standard = 'standard',
    image = 'image',
    none='none'
}


export type LocalizationInformation =
{
    GMTOffset : number,
    CountryCode: string,
    TimeZoneCode: string,
    CurrencyCode: string
}

export type CurrencyRate =
{
    GBP: number,
    USD: number,
    EUR: number
}
/*
export const defaultLocalizationInformation : LocalizationInformation=
{
    CountryCode: "GB",
    GMTOffset:0,
    TimeZoneCode:"GMT",
    CurrencyCode:"GBP"
}*/

export type RusContextProps = 
{
  localizationInformation : LocalizationInformation | null,
  currencies : CurrencyRate [] | null,
  //tutorMap : Map<number, string> | null,
  timeOffset: number | null,
  tutors: Tutor [] | null,
  setLocalizationInformation : React.Dispatch<LocalizationInformation>,
  hidePopUp : boolean,
  setHidePopUp : React.Dispatch<boolean>,
  setShoppingCartItem:  (x: (ShoppingCartItem|null)) => void,
  shoppingCartItem: ShoppingCartItem | null
}

export type RusAuthProps =
{
    clerkAuth?: any,
    userInformation?: UserInformation,
    authToken?: string,
    authTokenRef: React.MutableRefObject<string | undefined> | undefined,
    logOut: () => Promise<void>,
    refreshUserInformation: () => void,
    //logIn: (userName: string, password: string, remember: boolean) => Promise<void>
}

export type WPUserLogin =
{
    user_id?: number,
    user_email?:string,
    user_login?:string,
    logged_in: boolean
}

export enum SubscriptionStatus
{
    unknown = "unknown",
    active = "active",
    cancelled="cancelled",
    pendingCancellation="pending-cancellation"

}
export type UserInformation = {
    user_id: number,
    subscribed: boolean,
    status: SubscriptionStatus
    subscriber_level?:SubscriberLevel,
    expiry_date_utc_ticks?: number,
    is_fixed_term?: boolean,
    userName?: string,
    email?: string,
    is_admin?: boolean,
    expired: boolean,
    firstName?: string,
    lastName?:string,
    dateRegistered?: string
}

export interface Video {
    id: number,
    title: string,
    thumbnail: string,
    isSeries: boolean,
    description: string,
    vimeoId: number,
    vimeoH: string,
    subscriberLevel: string,
    dateLive: string,
    bookingUrl: string,
    privateRedirect: string,
    inTheFuture: boolean,
    accessible: boolean,
    tutorId: number,
    slug: string,
    excludeFromUpcoming: boolean,
    encodingStatus: number,
    hasSubtitles:boolean,
    tutor:
    {
        id: number,
        name:string
    }
    htmlDescription: string,
    chatId: string,
    isTrailer: boolean,
    duration: number,
    password?: string,
    isLiveSession?: boolean
}

export interface JWPlayerProps {
    video: Video;
    large?: boolean;
    placeHolder?:JSX.Element;
    dateProcessed: string;
    uniqueKey?: string;
    videoFinished?: ()=>void
}

export interface JWHostedPlayerProps
{
    jwId : string,
    autostart: boolean,
    controls: boolean,
    loop: boolean,
    mute: boolean
}

export type Tutor =
{
    id : number,
    name: string
}

export type PlayList =
{
    description: string,
    longDescription: string,
    id: number,
    slug: string,
    sequence: number | null,
    imageSlug: string | null
}

export type ImageSearchResult = {
    count: number;
    timeStamp: Date;
    photos: Array<Photo>;
}

export type SearchJson = {
    PoseType?: string;
    Ages?: string[] | null;
    Nude?: boolean | null;
    HeadDirections?: string[] | null;
    ReferenceType?: string | null;
    Genders?: string[] | null;
    SkinTones?: string[] | null;
    BodyTypes?: string[] | null;
    HairLengths?: string[] | null;
    FigurePoseTypes?: string[] | null;
    Expressive?: boolean | null;
    Drapery?: boolean | null;
    Eyes?: boolean | null;
    Ears?: boolean | null;
    Mouth?: boolean | null;
    Nose?: boolean | null;
    Torso?: boolean | null;
    Legs?: boolean | null;
    Back?: boolean | null;
    FacialHair?: boolean | null;
    Arms?: boolean | null;
    FancyDress?: boolean | null;
    DramaticLighting?: boolean | null;
    ColouredLighting?: boolean | null;
    ColouredBackground?: boolean | null;
    ModelId?: number | null;
    Materials?: string[] | null;
    QuickPoses?: boolean | null;
    VideoTypes?: string[] | null;
    DateFrom?: string | null;
    DateTo?: string | null;
    TutorId?: number | null;
    SubjectType?: string | null;
    Count: number;
    Offset: number;
    FreeText?: string | null;
    Slug?: string | null;
    Password?: string | null;
    Redirect?: string | null;
    VideoIds?: number [];
    PhotoId?: number;
}

export type VideoSearchResult = {
    count: number;
    timeStamp: Date;
    videos: Array<Video>;
}

export interface Photo {
    credit?: string;
    id: number,
    thumbnailFile: string,
    imageFile: string,
    extraLargeFile: string,
    pixelatedFile: string,
    thumbnailWidth: number,
    thumbnailHeight: number,
    isFree: number,
    width: number,
    height: number,
    description: string,
    orientation:number,
    modelId: number
}

export type VideoAncillaryLink=
{
    url: string,
    description: string,
    notLive: boolean
}

export enum ShoppingCartItemType
{
    onlineSession="online-session",
    workshop="workshop",
    subscription="subscription",
    gift="gift",
    none="none",
    upgrade="upgrade",
    paymentUpdate="payment-update",
}

export interface ShoppingCartItem
{
    itemType : ShoppingCartItemType,
    data? : any,
    quantity?: number,
    emailAddress?: string,
    firstName?: string,
    lastName?:string,
    countryCode?: string,
    stateCode?: string,
    optIn?: boolean,
    phoneNumber?: string
}

export interface OnlineSessionShoppingCartItem extends ShoppingCartItem
{
    data: {
        videoId : number
    }
}

export interface WorkshopShoppingCartItem extends ShoppingCartItem
{
    data: {
        workshopId : number,
        waitlist: boolean,
        notes?: string,
        workshop?: string,
        voucher?:string
    }
}

export interface SubscriptionShoppingCartItem extends ShoppingCartItem
{
    data: {
        level: SubscriberLevel,
        userName: string,
        planId?: string
    }
}

export interface PaymentUpdateShoppingCartItem extends ShoppingCartItem
{
    data:
    { 
        stripeCustomer?: string;
        wpUserId?: number;
    }
  
}

export type GiftVoucher = 
{
    code: string,
    level: SubscriberLevel,
    months: number,
    redeemed: boolean,
    emailAddress?: string
}


export interface GiftShoppingCartItem extends ShoppingCartItem
{
    data: {
        level: SubscriberLevel,
        giftMonths: number,
        giftVoucher?: string,
        giftVoucherId?: number
    }
}

export type CheckoutInformation =
{
    url: string,
    providerId: string
}

export interface CountryCode {
    Code: string,
    Name: string
}

export interface StateCode{
    name: string,
    abbreviation: string
}

export const countryCodes: CountryCode[] =
    [
        { "Code": "GB", "Name": "United Kingdom" },
        { "Code": "US", "Name": "United States" },
        { "Code": "AU", "Name": "Australia" },
        { "Code": "CA", "Name": "Canada" },
        { "Code": "FR", "Name": "France" },
        { "Code": "DE", "Name": "Germany" },
        { "Code": "IE", "Name": "Ireland" },
        { "Code": "NL", "Name": "Netherlands" },
        { "Code": "ES", "Name": "Spain" },
        
        { "Code": "AF", "Name": "Afghanistan" }, { "Code": "AX", "Name": "\u00c5land Islands" }, { "Code": "AL", "Name": "Albania" }, { "Code": "DZ", "Name": "Algeria" }, { "Code": "AS", "Name": "American Samoa" }, { "Code": "AD", "Name": "Andorra" }, { "Code": "AO", "Name": "Angola" }, { "Code": "AI", "Name": "Anguilla" }, { "Code": "AQ", "Name": "Antarctica" }, { "Code": "AG", "Name": "Antigua and Barbuda" }, { "Code": "AR", "Name": "Argentina" }, { "Code": "AM", "Name": "Armenia" }, { "Code": "AW", "Name": "Aruba" }, { "Code": "AU_", "Name": "Australia" }, { "Code": "AT", "Name": "Austria" }, { "Code": "AZ", "Name": "Azerbaijan" }, { "Code": "BS", "Name": "Bahamas" }, { "Code": "BH", "Name": "Bahrain" }, { "Code": "BD", "Name": "Bangladesh" }, { "Code": "BB", "Name": "Barbados" }, { "Code": "BY", "Name": "Belarus" }, { "Code": "BE", "Name": "Belgium" }, { "Code": "BZ", "Name": "Belize" }, { "Code": "BJ", "Name": "Benin" }, { "Code": "BM", "Name": "Bermuda" }, { "Code": "BT", "Name": "Bhutan" }, { "Code": "BO", "Name": "Bolivia, Plurinational State of" }, { "Code": "BQ", "Name": "Bonaire, Sint Eustatius and Saba" }, { "Code": "BA", "Name": "Bosnia and Herzegovina" }, { "Code": "BW", "Name": "Botswana" }, { "Code": "BV", "Name": "Bouvet Island" }, { "Code": "BR", "Name": "Brazil" }, { "Code": "IO", "Name": "British Indian Ocean Territory" }, { "Code": "BN", "Name": "Brunei Darussalam" }, { "Code": "BG", "Name": "Bulgaria" }, { "Code": "BF", "Name": "Burkina Faso" }, { "Code": "BI", "Name": "Burundi" }, { "Code": "KH", "Name": "Cambodia" }, { "Code": "CM", "Name": "Cameroon" }, { "Code": "CA_", "Name": "Canada" }, { "Code": "CV", "Name": "Cape Verde" }, { "Code": "KY", "Name": "Cayman Islands" }, { "Code": "CF", "Name": "Central African Republic" }, { "Code": "TD", "Name": "Chad" }, { "Code": "CL", "Name": "Chile" }, { "Code": "CN", "Name": "China" }, { "Code": "CX", "Name": "Christmas Island" }, { "Code": "CC", "Name": "Cocos (Keeling) Islands" }, { "Code": "CO", "Name": "Colombia" }, { "Code": "KM", "Name": "Comoros" }, { "Code": "CG", "Name": "Congo" }, { "Code": "CD", "Name": "Congo, the Democratic Republic of the" }, { "Code": "CK", "Name": "Cook Islands" }, { "Code": "CR", "Name": "Costa Rica" }, { "Code": "CI", "Name": "C\u00f4te d'Ivoire" }, { "Code": "HR", "Name": "Croatia" }, { "Code": "CU", "Name": "Cuba" }, { "Code": "CW", "Name": "Cura\u00e7ao" }, { "Code": "CY", "Name": "Cyprus" }, { "Code": "CZ", "Name": "Czech Republic" }, { "Code": "DK", "Name": "Denmark" }, { "Code": "DJ", "Name": "Djibouti" }, { "Code": "DM", "Name": "Dominica" }, { "Code": "DO", "Name": "Dominican Republic" }, { "Code": "EC", "Name": "Ecuador" }, { "Code": "EG", "Name": "Egypt" }, { "Code": "SV", "Name": "El Salvador" }, { "Code": "GQ", "Name": "Equatorial Guinea" }, { "Code": "ER", "Name": "Eritrea" }, { "Code": "EE", "Name": "Estonia" }, { "Code": "ET", "Name": "Ethiopia" }, { "Code": "FK", "Name": "Falkland Islands (Malvinas)" }, { "Code": "FO", "Name": "Faroe Islands" }, { "Code": "FJ", "Name": "Fiji" }, { "Code": "FI", "Name": "Finland" }, { "Code": "FR_", "Name": "France" }, { "Code": "GF", "Name": "French Guiana" }, { "Code": "PF", "Name": "French Polynesia" }, { "Code": "TF", "Name": "French Southern Territories" }, { "Code": "GA", "Name": "Gabon" }, { "Code": "GM", "Name": "Gambia" }, { "Code": "GE", "Name": "Georgia" }, { "Code": "DE_", "Name": "Germany" }, { "Code": "GH", "Name": "Ghana" }, { "Code": "GI", "Name": "Gibraltar" }, { "Code": "GR", "Name": "Greece" }, { "Code": "GL", "Name": "Greenland" }, { "Code": "GD", "Name": "Grenada" }, { "Code": "GP", "Name": "Guadeloupe" }, { "Code": "GU", "Name": "Guam" }, { "Code": "GT", "Name": "Guatemala" }, { "Code": "GG", "Name": "Guernsey" }, { "Code": "GN", "Name": "Guinea" }, { "Code": "GW", "Name": "Guinea-Bissau" }, { "Code": "GY", "Name": "Guyana" }, { "Code": "HT", "Name": "Haiti" }, { "Code": "HM", "Name": "Heard Island and McDonald Islands" }, { "Code": "VA", "Name": "Holy See (Vatican City State)" }, { "Code": "HN", "Name": "Honduras" }, { "Code": "HK", "Name": "Hong Kong" }, { "Code": "HU", "Name": "Hungary" }, { "Code": "IS", "Name": "Iceland" }, { "Code": "IN", "Name": "India" }, { "Code": "ID", "Name": "Indonesia" }, { "Code": "IR", "Name": "Iran, Islamic Republic of" }, { "Code": "IQ", "Name": "Iraq" }, { "Code": "IE_", "Name": "Ireland" }, { "Code": "IM", "Name": "Isle of Man" }, { "Code": "IL", "Name": "Israel" }, { "Code": "IT", "Name": "Italy" }, { "Code": "JM", "Name": "Jamaica" }, { "Code": "JP", "Name": "Japan" }, { "Code": "JE", "Name": "Jersey" }, { "Code": "JO", "Name": "Jordan" }, { "Code": "KZ", "Name": "Kazakhstan" }, { "Code": "KE", "Name": "Kenya" }, { "Code": "KI", "Name": "Kiribati" }, { "Code": "KP", "Name": "Korea, Democratic People's Republic of" }, { "Code": "KR", "Name": "Korea, Republic of" }, { "Code": "KW", "Name": "Kuwait" }, { "Code": "KG", "Name": "Kyrgyzstan" }, { "Code": "LA", "Name": "Lao People's Democratic Republic" }, { "Code": "LV", "Name": "Latvia" }, { "Code": "LB", "Name": "Lebanon" }, { "Code": "LS", "Name": "Lesotho" }, { "Code": "LR", "Name": "Liberia" }, { "Code": "LY", "Name": "Libya" }, { "Code": "LI", "Name": "Liechtenstein" }, { "Code": "LT", "Name": "Lithuania" }, { "Code": "LU", "Name": "Luxembourg" }, { "Code": "MO", "Name": "Macao" }, { "Code": "MK", "Name": "Macedonia, the Former Yugoslav Republic of" }, { "Code": "MG", "Name": "Madagascar" }, { "Code": "MW", "Name": "Malawi" }, { "Code": "MY", "Name": "Malaysia" }, { "Code": "MV", "Name": "Maldives" }, { "Code": "ML", "Name": "Mali" }, { "Code": "MT", "Name": "Malta" }, { "Code": "MH", "Name": "Marshall Islands" }, { "Code": "MQ", "Name": "Martinique" }, { "Code": "MR", "Name": "Mauritania" }, { "Code": "MU", "Name": "Mauritius" }, { "Code": "YT", "Name": "Mayotte" }, { "Code": "MX", "Name": "Mexico" }, { "Code": "FM", "Name": "Micronesia, Federated States of" }, { "Code": "MD", "Name": "Moldova, Republic of" }, { "Code": "MC", "Name": "Monaco" }, { "Code": "MN", "Name": "Mongolia" }, { "Code": "ME", "Name": "Montenegro" }, { "Code": "MS", "Name": "Montserrat" }, { "Code": "MA", "Name": "Morocco" }, { "Code": "MZ", "Name": "Mozambique" }, { "Code": "MM", "Name": "Myanmar" }, { "Code": "NA", "Name": "Namibia" }, { "Code": "NR", "Name": "Nauru" }, { "Code": "NP", "Name": "Nepal" },  { "Code": "NC", "Name": "New Caledonia" }, { "Code": "NZ", "Name": "New Zealand" }, { "Code": "NI", "Name": "Nicaragua" }, { "Code": "NE", "Name": "Niger" }, { "Code": "NG", "Name": "Nigeria" }, { "Code": "NU", "Name": "Niue" }, { "Code": "NF", "Name": "Norfolk Island" }, { "Code": "MP", "Name": "Northern Mariana Islands" }, { "Code": "NO", "Name": "Norway" }, { "Code": "OM", "Name": "Oman" }, { "Code": "PK", "Name": "Pakistan" }, { "Code": "PW", "Name": "Palau" }, { "Code": "PS", "Name": "Palestine, State of" }, { "Code": "PA", "Name": "Panama" }, { "Code": "PG", "Name": "Papua New Guinea" }, { "Code": "PY", "Name": "Paraguay" }, { "Code": "PE", "Name": "Peru" }, { "Code": "PH", "Name": "Philippines" }, { "Code": "PN", "Name": "Pitcairn" }, { "Code": "PL", "Name": "Poland" }, { "Code": "PT", "Name": "Portugal" }, { "Code": "PR", "Name": "Puerto Rico" }, { "Code": "QA", "Name": "Qatar" }, { "Code": "RE", "Name": "R\u00e9union" }, { "Code": "RO", "Name": "Romania" }, { "Code": "RU", "Name": "Russian Federation" }, { "Code": "RW", "Name": "Rwanda" }, { "Code": "BL", "Name": "Saint Barth\u00e9lemy" }, { "Code": "SH", "Name": "Saint Helena, Ascension and Tristan da Cunha" }, { "Code": "KN", "Name": "Saint Kitts and Nevis" }, { "Code": "LC", "Name": "Saint Lucia" }, { "Code": "MF", "Name": "Saint Martin (French part)" }, { "Code": "PM", "Name": "Saint Pierre and Miquelon" }, { "Code": "VC", "Name": "Saint Vincent and the Grenadines" }, { "Code": "WS", "Name": "Samoa" }, { "Code": "SM", "Name": "San Marino" }, { "Code": "ST", "Name": "Sao Tome and Principe" }, { "Code": "SA", "Name": "Saudi Arabia" }, { "Code": "SN", "Name": "Senegal" }, { "Code": "RS", "Name": "Serbia" }, { "Code": "SC", "Name": "Seychelles" }, { "Code": "SL", "Name": "Sierra Leone" }, { "Code": "SG", "Name": "Singapore" }, { "Code": "SX", "Name": "Sint Maarten (Dutch part)" }, { "Code": "SK", "Name": "Slovakia" }, { "Code": "SI", "Name": "Slovenia" }, { "Code": "SB", "Name": "Solomon Islands" }, { "Code": "SO", "Name": "Somalia" }, { "Code": "ZA", "Name": "South Africa" }, { "Code": "GS", "Name": "South Georgia and the South Sandwich Islands" }, { "Code": "SS", "Name": "South Sudan" }, { "Code": "ES_", "Name": "Spain" }, { "Code": "LK", "Name": "Sri Lanka" }, { "Code": "SD", "Name": "Sudan" }, { "Code": "SR", "Name": "Suriname" }, { "Code": "SJ", "Name": "Svalbard and Jan Mayen" }, { "Code": "SZ", "Name": "Swaziland" }, { "Code": "SE", "Name": "Sweden" }, { "Code": "CH", "Name": "Switzerland" }, { "Code": "SY", "Name": "Syrian Arab Republic" }, { "Code": "TW", "Name": "Taiwan, Province of China" }, { "Code": "TJ", "Name": "Tajikistan" }, { "Code": "TZ", "Name": "Tanzania, United Republic of" }, { "Code": "TH", "Name": "Thailand" }, { "Code": "TL", "Name": "Timor-Leste" }, { "Code": "TG", "Name": "Togo" }, { "Code": "TK", "Name": "Tokelau" }, { "Code": "TO", "Name": "Tonga" }, { "Code": "TT", "Name": "Trinidad and Tobago" }, { "Code": "TN", "Name": "Tunisia" }, { "Code": "TR", "Name": "Turkey" }, { "Code": "TM", "Name": "Turkmenistan" }, { "Code": "TC", "Name": "Turks and Caicos Islands" }, { "Code": "TV", "Name": "Tuvalu" }, { "Code": "UG", "Name": "Uganda" }, { "Code": "UA", "Name": "Ukraine" }, { "Code": "AE", "Name": "United Arab Emirates" }, { "Code": "GB_", "Name": "United Kingdom" }, { "Code": "US_", "Name": "United States" }, { "Code": "UM", "Name": "United States Minor Outlying Islands" }, { "Code": "UY", "Name": "Uruguay" }, { "Code": "UZ", "Name": "Uzbekistan" }, { "Code": "VU", "Name": "Vanuatu" }, { "Code": "VE", "Name": "Venezuela, Bolivarian Republic of" }, { "Code": "VN", "Name": "Viet Nam" }, { "Code": "VG", "Name": "Virgin Islands, British" }, { "Code": "VI", "Name": "Virgin Islands, U.S." }, { "Code": "WF", "Name": "Wallis and Futuna" }, { "Code": "EH", "Name": "Western Sahara" }, { "Code": "YE", "Name": "Yemen" }, { "Code": "ZM", "Name": "Zambia" }, { "Code": "ZW", "Name": "Zimbabwe" }
    ];

export const stateCodes: StateCode[] =
    [{
        "name": "Alabama",
        "abbreviation": "AL"
    },
    {
        "name": "Alaska",
        "abbreviation": "AK"
    },
    {
        "name": "American Samoa",
        "abbreviation": "AS"
    },
    {
        "name": "Arizona",
        "abbreviation": "AZ"
    },
    {
        "name": "Arkansas",
        "abbreviation": "AR"
    },
    {
        "name": "California",
        "abbreviation": "CA"
    },
    {
        "name": "Colorado",
        "abbreviation": "CO"
    },
    {
        "name": "Connecticut",
        "abbreviation": "CT"
    },
    {
        "name": "Delaware",
        "abbreviation": "DE"
    },
    {
        "name": "District Of Columbia",
        "abbreviation": "DC"
    },
    {
        "name": "Federated States Of Micronesia",
        "abbreviation": "FM"
    },
    {
        "name": "Florida",
        "abbreviation": "FL"
    },
    {
        "name": "Georgia",
        "abbreviation": "GA"
    },
    {
        "name": "Guam",
        "abbreviation": "GU"
    },
    {
        "name": "Hawaii",
        "abbreviation": "HI"
    },
    {
        "name": "Idaho",
        "abbreviation": "ID"
    },
    {
        "name": "Illinois",
        "abbreviation": "IL"
    },
    {
        "name": "Indiana",
        "abbreviation": "IN"
    },
    {
        "name": "Iowa",
        "abbreviation": "IA"
    },
    {
        "name": "Kansas",
        "abbreviation": "KS"
    },
    {
        "name": "Kentucky",
        "abbreviation": "KY"
    },
    {
        "name": "Louisiana",
        "abbreviation": "LA"
    },
    {
        "name": "Maine",
        "abbreviation": "ME"
    },
    {
        "name": "Marshall Islands",
        "abbreviation": "MH"
    },
    {
        "name": "Maryland",
        "abbreviation": "MD"
    },
    {
        "name": "Massachusetts",
        "abbreviation": "MA"
    },
    {
        "name": "Michigan",
        "abbreviation": "MI"
    },
    {
        "name": "Minnesota",
        "abbreviation": "MN"
    },
    {
        "name": "Mississippi",
        "abbreviation": "MS"
    },
    {
        "name": "Missouri",
        "abbreviation": "MO"
    },
    {
        "name": "Montana",
        "abbreviation": "MT"
    },
    {
        "name": "Nebraska",
        "abbreviation": "NE"
    },
    {
        "name": "Nevada",
        "abbreviation": "NV"
    },
    {
        "name": "New Hampshire",
        "abbreviation": "NH"
    },
    {
        "name": "New Jersey",
        "abbreviation": "NJ"
    },
    {
        "name": "New Mexico",
        "abbreviation": "NM"
    },
    {
        "name": "New York",
        "abbreviation": "NY"
    },
    {
        "name": "North Carolina",
        "abbreviation": "NC"
    },
    {
        "name": "North Dakota",
        "abbreviation": "ND"
    },
    {
        "name": "Northern Mariana Islands",
        "abbreviation": "MP"
    },
    {
        "name": "Ohio",
        "abbreviation": "OH"
    },
    {
        "name": "Oklahoma",
        "abbreviation": "OK"
    },
    {
        "name": "Oregon",
        "abbreviation": "OR"
    },
    {
        "name": "Palau",
        "abbreviation": "PW"
    },
    {
        "name": "Pennsylvania",
        "abbreviation": "PA"
    },
    {
        "name": "Puerto Rico",
        "abbreviation": "PR"
    },
    {
        "name": "Rhode Island",
        "abbreviation": "RI"
    },
    {
        "name": "South Carolina",
        "abbreviation": "SC"
    },
    {
        "name": "South Dakota",
        "abbreviation": "SD"
    },
    {
        "name": "Tennessee",
        "abbreviation": "TN"
    },
    {
        "name": "Texas",
        "abbreviation": "TX"
    },
    {
        "name": "Utah",
        "abbreviation": "UT"
    },
    {
        "name": "Vermont",
        "abbreviation": "VT"
    },
    {
        "name": "Virgin Islands",
        "abbreviation": "VI"
    },
    {
        "name": "Virginia",
        "abbreviation": "VA"
    },
    {
        "name": "Washington",
        "abbreviation": "WA"
    },
    {
        "name": "West Virginia",
        "abbreviation": "WV"
    },
    {
        "name": "Wisconsin",
        "abbreviation": "WI"
    },
    {
        "name": "Wyoming",
        "abbreviation": "WY"
    }
    ];


    export class WPError extends Error
        {

        constructor(message : string)
        {
            super(message);

            this.name = "WPError";
        }
    }

    
    export class RUSError extends Error
        {

        constructor(message : string)
        {
            super(message);
            this.name = "RUSError";
        }
    }

    export type Payment =
    {
        currency: string;
        dateTransacted: string;
        paymentProvider: string;
        amount: number;
    }

    export enum ProcessorType 
    {
        paypal="paypal",
        stripe="stripe"
    }
    export type PaymentInformation =
    {
        processor: ProcessorType,
        subscriptionId : string,
        planId: string
    }

export type ThreeDModel = 
{
    rotate? : boolean, 
    replaceMaterial?: boolean,
    hasColours?: boolean,
    hasTexture?: boolean,
    hasLabels? :boolean, 
    replaceColour?: boolean,
    name?: string,
    description?: string,
    seoDescription?: string,
    subscriberOnly?:boolean,
    accessible?: boolean,
    filename?: string,
    previewFilename?: string,
    previewVideo?: string,
    slug?: string
}

export enum WorkshopStatus
{
    live = "live",
    draft = "draft",
    cancelled = "cancelled",
    full="full"
}

export type Workshop=
{
    id: number,
    title : string,
    dateStart: string,
    dateEnd: string,
    length: number,
    tutor:string,
    totalTickets: number,
    excerpt: string,
    description: string,
    slug: string,
    price: number,
    ticketsSold: number,
    galleryId: number,
    imageId:number,
    status: WorkshopStatus,
    halfDay: number
}

export type ImageData =
{
    id: number,
    width: number,
    height: number,
    updatedAt: number,
    filename: string,
    description?: string,
    altText?: string
}


export interface WPSection
{
    tag:string,
    contents:string | WPSection[],
    fullTag:string,
    data: any,
}

export interface WPBlock // mimics ParsedBlock
{
    blockName : string | null,
    attrs: Attributes,
    innerBlocks: WPBlock [] | null,
    innerHTML: string,
    innerContent: Array<string|null>
    extraData: any,
    parsedHTML?: string
}

export interface WPNggBlock extends WPBlock
{
    extraData :
    {
        shortcode: string,
        imageData: ImageData [];
    }

}

export interface WPImageBlock extends WPBlock
{
    extraData : ImageData & {sizeSlug: string}
}

export interface WPVideoBlock extends WPBlock
{
    extraData :
    {
        shortcode: string,
        video: Video;
    }

}

export interface JWVideoBlock extends WPBlock
{
    extraData :
    {
        shortcode: string,
        jwId: string;
        autostart: boolean,
        controls: boolean,
        loop: boolean,
        mute: boolean
    }

}

export type WPPost = 
{
    id: number,
    date: string,
    title: string,
    contents: WPBlock[],
    excerpt: string,
    slug: string,
    imageData: ImageData | null,
    type:string
}

export type YoastData =
{
    title : string,
    description: string,
    noIndex: boolean,
    image: string
}


export type Redirect=
{
    from:string,
    to:string
}

export type ModelApplication =
{
    firstName?: string,
    lastName?: string,
    email?: string,
    phoneNumber?: string,
    website?: string,
    city?: string,
    country?: string,
    gender?: string,
    pronouns?:string,
    features?: string,
    experience?:string,
    appearance?:string,
    portrait?:boolean,
    nude?:boolean,
    clothed?:boolean
}

export type ShowcaseApplication =
{
    firstName?: string,
    lastName?: string,
    email?: string,
    information?: string,
}

export type PrizeApplication =
{
    firstName?: string,
    lastName?: string,
    email?: string,
    sharing?: string,
    subscribeToList?:string,
    phoneNumber?:string
}

export type Under40Application =
{
    firstName?: string,
    lastName?: string,
    email?: string,
    instagram?:string,
    age?:string
}


export type UserImage =
{
    id : number,
    guid: string,
    dateCreated: string,
    rotation: number,
    width: number,
    height: number,
    description: string,
    user: {id: number, userName: string },
    likeCount: number,
    commentCount: number,
    hasLiked: boolean,
    instagram:
    {
        permalink:string,
        userName: string
    }
}
export type UserImageSearchResult = 
{
    images: UserImage [], 
    count: number,
    timestamp:string
}

export type UserImageSearchInformation =
{
    offset: number,
    count: number,
    userId: number
}

export type UserMetadata = 
{
    avatarGuid?: string,
    dateRegistered?: DateTime,
    IsActive?: boolean
}

export type PollAnswer=
{
    id?:number,
    title:string,
    count?:number
}

export type Poll =
{
    answers : PollAnswer[],
    id?: number,
    title: string,
    responseCount?: number,
    maxAnswers: number
}

export type PollVote =
{
    pollId : number,
    answerIds : number[]
}

export type ShowcaseItem =
{
    url : string,
    artist: string,
    imageData: ImageData,
    id: number,
    artistLink: string | null
}